import React from "react";
import { getImageUrl } from "utils/imageHelper";

export default function ViewProgramDetails({ data }) {
  if (!data) return null;

  const formattedDate = data.programDate
    ? new Date(data.programDate.split("T")[0] + "T00:00:00").toLocaleDateString(
        "en-US",
        {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      )
    : "N/A";

  // Normalize program type string (supports populated object or string value)
  const rawType =
    typeof data.programType_id === "object"
      ? data.programType_id?.name
      : data.programType || data.programType_id;

  const programTypeLower = (rawType || "").toLowerCase().trim();

  const isMeeting = programTypeLower === "meeting";
  const isBreak = programTypeLower === "break";
  const isOther = programTypeLower === "other";

  const hasDescription = isMeeting || isOther;

  return (
    <div className="flex flex-col gap-6 text-sm text-gray-800">
      {/* General Details Section */}
      <div className="view-card flex flex-col gap-6">
        <div className="view-subtitle">
          <span>Program Details</span>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p className="view-label">Title</p>
            <p className="view-value font-semibold">{data.title || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">Program Type</p>
            <p className="view-value capitalize">{rawType || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">Program Date</p>
            <p className="view-value">{formattedDate}</p>
          </div>

          <div>
            <p className="view-label">Start Time</p>
            <p className="view-value">{data.startTime || "N/A"}</p>
          </div>
        </div>
      </div>

      {/* Description & Speakers Section (Meeting or Other) */}
      {hasDescription && (
        <div className="view-card flex flex-col gap-6">
          <div className="view-subtitle">
            <span>{isOther ? "Additional Details" : "Meeting Details"}</span>
          </div>

          <div className="grid grid-cols-1 gap-4">
            <div>
              <p className="view-label">Description</p>
              <p className="view-value leading-relaxed">
                {data.description || "N/A"}
              </p>
            </div>

            {isMeeting && (
              <div>
                <p className="view-label">Assigned Speaker(s)</p>
                <div className="mt-2 flex flex-wrap gap-2">
                  {Array.isArray(data.speakers) && data.speakers.length > 0 ? (
                    data.speakers.map((s) => {
                      const speakerName = typeof s === "object" ? s.name : s;
                      const speakerEmail = typeof s === "object" ? s.email : "";

                      return (
                        <span
                          key={typeof s === "object" ? s._id || s.id : s}
                          className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700"
                        >
                          {speakerName}{" "}
                          {speakerEmail ? `(${speakerEmail})` : ""}
                        </span>
                      );
                    })
                  ) : (
                    <p className="view-value">No speakers assigned</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Break Image Section */}
      {isBreak && (
        <div className="view-card flex flex-col gap-6">
          <div className="view-subtitle">
            <span>Break Media</span>
          </div>

          <div>
            <p className="view-label">Break Image</p>
            {data.image ? (
              <div className="mt-2">
                <img
                  src={getImageUrl(data.image)}
                  alt="Break Media"
                  className="h-40 max-w-xs rounded-lg border object-cover shadow-sm"
                />
              </div>
            ) : (
              <p className="view-value text-gray-400">No image uploaded</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
